import { render, staticRenderFns } from "./WorkBookSectionScore.vue?vue&type=template&id=38a110ed&scoped=true&"
import script from "./WorkBookSectionScore.vue?vue&type=script&lang=js&"
export * from "./WorkBookSectionScore.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookSectionScore.vue?vue&type=style&index=0&id=38a110ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a110ed",
  null
  
)

export default component.exports